import InternationalVisitsUpgradeBanner from "app/pages/sales-intelligence/common-components/feature-upgrade/InternationalVisitsUpgradeBanner/InternationalVisitsUpgradeBanner";
import { filterUsageMap } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterDefinition";

import InternationalVisitsFilter from "../../components/filters/InternationalVisitsFilter/InternationalVisitsFilter";
import InternationalVisitsFilterResult from "../../components/filters/InternationalVisitsFilter/InternationalVisitsFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindInternationalVisitsFilter from "./InternationalVisitsFilter";

export const internationalFiltersDefinition = defineDescriptionFilter({
    key: "internationalFilters",
    apiCategory: leadsFilterApiCategory.internationalFilters,
    category: leadsFilterCategoryMap.trafficAndEngagement,
    usages: [filterUsageMap.search, filterUsageMap.territory],
    trackingName: "International Visits",
    titleKey: { key: "si.lead_gen_filters.international_visits.name" },

    render: ({ description, countryService }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.international_visits.tooltip" },
        filter: new FindInternationalVisitsFilter({
            options: {
                countriesOptions: countryService.trafficCountriesWithoutWorldwide,
                buckets: description.bucketsDescription.internationalVisits,
            },
        }),
        filterView: InternationalVisitsFilter,
        filterResultView: InternationalVisitsFilterResult,
        gateStatus: countryService.isWorldwideAvailable
            ? undefined
            : { type: "upgrade", view: InternationalVisitsUpgradeBanner },
    }),
});
